import React, { useCallback, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { LoadMore, Modal, Reviews } from '../../components';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { queryUserReviews } from './ProfilePage.duck';
import { useDispatch, useSelector } from 'react-redux';

import css from './ProfilePage.module.css';

const ReviewsModal = props => {
  const { reviews, fetchParams, pagination } = props;
  const dispatch = useDispatch();
  const { queryReviewsInProgress } = useSelector(state => state.ProfilePage);

  const [isReviewModalOpen, setIsReviewModalOpen] = useState();

  const onManageDisableScrolling = useCallback(
    (componentId, disableScrolling) =>
      dispatch(manageDisableScrolling(componentId, disableScrolling)),
    [dispatch]
  );

  const handleLoadMoreReviews = params => {
    dispatch(queryUserReviews(params));
  };

  return (
    <>
      {reviews.length > 2 && (
        <button className={css.secondaryButton} onClick={() => setIsReviewModalOpen(true)}>
          <FormattedMessage id="ListingPage.showAllReviews" />
        </button>
      )}

      <Modal
        containerClassName={css.modalContainer}
        contentClassName={css.modalContent}
        id="ReviewsModal"
        isOpen={isReviewModalOpen}
        onClose={() => setIsReviewModalOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
      >
        <div>
          <Reviews className={css.modalReviews} reviews={isReviewModalOpen ? reviews : []} />

          {isReviewModalOpen && (
            <LoadMore
              fetchParams={fetchParams}
              pagination={pagination}
              onClickLoadMore={handleLoadMoreReviews}
              inProgress={queryReviewsInProgress}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ReviewsModal;
